import { Component, OnInit, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef } from '@angular/material/dialog';
import { aspMngr } from '../asp/AspMngr';
import * as interfaces from '../asp/interfaces';
import * as consts from '../common/consts';
import * as utils from '../common/utils';
import { mainMapMngr } from '../asp/MapMngr';
import { ZIndexMngr } from '../common/ZIndexMngr';
import { Animations } from '@core_n/Animations';
import { dialogType } from '@core_n/enums';

const MAX_SEARCH_RESULTS = 100;
const HIGHLIGHT_COLOR = 'orange';

@Component({
  selector: 'search-dialog',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class SearchDialogComponent extends ZIndexMngr implements OnInit, OnDestroy, AfterViewInit {

  searchPattern: string = '';
  foundObjects: interfaces.SearchResult[];
  foundObjectsTitles = new Array<any>();

  constructor(public dialogRef: MatDialogRef<SearchDialogComponent>,
              private domSanitizer: DomSanitizer,
              elementRef: ElementRef) {
    super(elementRef);
  }

  static createDialogConfig(upperBarHeight: number) {
    return utils.createDialogConfig(false, false, dialogType.search,
      { top: `${upperBarHeight + 5}px`, right: `80px` });
  }

  ngOnInit() {
    this.dialogRaise();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    this.dialogClosed();
  }

  clearSearchPattern() {
    this.searchPattern = '';
    this.onSearchPatternInput(this.searchPattern);
  }

  onSearchPatternInput(search: string) {
    this.foundObjectsTitles.length = 0;
    if (search.length > 0) {
      this.foundObjects = aspMngr.searchObjects(search).slice(0, MAX_SEARCH_RESULTS);
      this.sortResults(search);
      for(let result of this.foundObjects)
        // this.foundObjectsTitles.push(this.highlightSearchPattern(`${result.identifier} (${result.obj.getTitle()})`, search));
        this.foundObjectsTitles.push(`${result.identifier} (${result.obj.getTitle()}`);
    }
  }

  onFoundObjectClick(foundObject, index) {
    // let index = this.foundObjectsTitles.indexOf(foundObject);
    if (index != -1) {
      // Open ARO and hook object
      let obj = this.foundObjects[index].obj;
      aspMngr.hookObject(obj);
      obj.objectsPool.handleUserAction(consts.USER_ACTION_ARO, obj, mainMapMngr);
    }
    this.dialogRef.close();
  }

  // Sort results to have all results starting with given search pattern ahead of all other matching results.
  // Each of the two groups is individually sorted alphabetically.
  private sortResults(search: string) {
    let lowerValue = search.toLocaleLowerCase();
    let startsResults = [];
    let otherResults = [];
    for(let result of this.foundObjects) {
      if (result.identifier.toLocaleLowerCase().startsWith(lowerValue))
        startsResults.push(result);
      else
        otherResults.push(result);
    }
    startsResults.sort(function(first: interfaces.SearchResult, second: interfaces.SearchResult) {
      return first.identifier.localeCompare(second.identifier);
    });
    otherResults.sort(function(first: interfaces.SearchResult, second: interfaces.SearchResult) {
      return first.identifier.localeCompare(second.identifier);
    });
    this.foundObjects = startsResults;
    this.foundObjects.push(...otherResults);
  }

  private highlightSearchPattern(ident: string, search: string) {
    let start = ident.toLowerCase().indexOf(search.toLocaleLowerCase());
    let prefix = ident.substring(0, start);
    let found = ident.substr(start, search.length);
    let suffix = ident.substring(start + search.length);
    let result = `<span>${prefix}</span><span style="font-weight: bold; color: ${HIGHLIGHT_COLOR}">
      ${found}</span><span>${suffix}</span>`;
    return this.domSanitizer.bypassSecurityTrustHtml(result);
  }
}
